module.exports = __webpack_public_path__ + "static/media/image-video-12.6ee5e18e.png";